export default __webpack_public_path__ + "static/media/blocksync.5b85bee7.svg";